import { render, staticRenderFns } from "./ImmediateBossesAdm.vue?vue&type=template&id=339159ba"
import script from "./ImmediateBossesAdm.vue?vue&type=script&lang=js"
export * from "./ImmediateBossesAdm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports